import { render, staticRenderFns } from "./DailyReportsPage.vue?vue&type=template&id=36ae0a00&"
import script from "./DailyReportsPage.vue?vue&type=script&lang=js&"
export * from "./DailyReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports